module.exports = function getResource(label, vars = []) {
    let resources = {
        emailAddress: 'Courriel',
        asMText: 'Si vous ne souhaitez plus recevoir d’avis, saisissez l’adresse courriel que vous désirez supprimer et cliquez sur « Supprimer ».',
        asMBText: 'Supprimer',
        nsMText: 'Pour recevoir un courriel pour vous avertir qu’un produit est en stock, il suffit de saisir votre adresse courriel et de cliquer sur « M’envoyer un courriel ».',
        nsMBText: 'Recevoir des courriels',
        empty: 'Veuillez saisir votre adresse courriel.',
        invalid: 'Veuillez saisir une adresse courriel au format username@domain.com.',
        subscribe: 'Votre courriel d’avis de produit en stock sera envoyé à ',
        remove: 'Vous n’êtes plus inscrit pour recevoir un courriel lorsque le produit sera en stock.',
        emailMe: 'M’envoyer un courriel lorsque le produit est disponible'
    };

    return resources[label];
};
